namespace $ {

	export class $shm_hitalama_vk_token extends $giper_baza_entity.with({

		Organization: $giper_baza_atom_text,
		Token: $giper_baza_atom_text,
		User_id: $giper_baza_atom_text,
		Avatar: $giper_baza_file,
		Avatar_url: $giper_baza_atom_text,
		
	}){

		static current() {
			const ref_str = $mol_state_local.value<string>( '$' + 'hitalama_vk_token_switch.current_link()' )!
			if( !ref_str ) return null
			const node = this.$.$giper_baza_glob!.Pawn( new $giper_baza_link( ref_str ), $shm_hitalama_vk_token )
			return node.Token()?.val()
		}
		
	}

	
}
